import {Injectable} from '@angular/core';
import {BaseDataService} from '../commons/base-data.service';
import {HelpersService} from '../../core/helpers/helpers.service';
import {HttpClient} from '@angular/common/http';
import {NewsItem} from './models/news-item';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

@Injectable()
export class NewsDataService extends BaseDataService {
  private newsData: Array<NewsItem> = null;

  constructor(private http: HttpClient,
              helpers: HelpersService) {
    super(helpers);
  }

  getNews(): Observable<NewsItem[]> {
    if (this.newsData) {
      return Observable.of(this.newsData).delay(100);
    } else {
      return this.http.get('assets/data/news.json').map((data: any) => {
        return this.newsData = <NewsItem[]>data;
      });
    }
  }

  getSingleNews(id: string | null) {
    return Observable.create((observer) => {
      this.getNews().subscribe(newsData => {
        const result = newsData.find((itm) => itm.id.toString() === id);
        observer.next(<NewsItem>result);
        observer.complete();
      });
    });
  }

}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/news/news-data.service.ts